import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthenticationStore = create(
  persist(
    (set) => ({
      user: {
        info: null,
        token: null,
        refreshToken: null,
        refreshExpiresIn: null,
        isLoggedIn: false,
        beingImpersonated: false,
      },
      impersonation: {
        isActive: false,
        originalSession: null,
      },
      setUser: ({
        token,
        refreshToken,
        refreshExpiresIn,
        preserveSession = false,
      }) =>
        set((state) => ({
          user: {
            ...state.user,
            info: preserveSession ? state.user.info : null,
            signInSession: preserveSession
              ? state.user.signInSession
              : uuidv4(),
            introductionSeen: preserveSession
              ? state.user.introductionSeen
              : false,
            token,
            refreshToken,
            refreshExpiresIn,
            isLoggedIn: true,
          },
        })),
      markIntroductionSeen: (session, userId) =>
        set((state) =>
          state.user.signInSession === session && state.user.info?.id === userId
            ? { user: { ...state.user, introductionSeen: true } }
            : {},
        ),
      startImpersonation: (impersonatedUser, originalSession) =>
        set(() => ({
          user: {
            ...impersonatedUser,
            isLoggedIn: true,
            beingImpersonated: true,
          },
          impersonation: {
            isActive: true,
            originalSession,
          },
        })),
      stopImpersonation: (navigate) =>
        set((state) => {
          const originalUser = state.impersonation.originalSession || {
            info: null,
            token: null,
            refreshToken: null,
            refreshExpiresIn: null,
            isLoggedIn: false,
            beingImpersonated: false,
          };

          // Navigate after updating state
          if (navigate) navigate("/");

          return {
            user: originalUser,
            impersonation: { isActive: false, originalSession: null },
          };
        }),
      logOutUser: () =>
        set(() => ({
          user: {
            info: null,
            token: null,
            refreshToken: null,
            refreshExpiresIn: null,
            isLoggedIn: false,
            beingImpersonated: false,
          },
          impersonation: { isActive: false, originalSession: null },
        })),
      updateUserInfo: (newInfo) =>
        set((state) => ({
          user: {
            ...state.user,
            info: {
              ...newInfo,
            },
          },
        })),
    }),
    {
      name: "authentication-storage", // Persist the store with a unique name
    },
  ),
);
